import "./App.css";
import IndexRouter from "./routers";
import "./i18n";

function App() {
  return <IndexRouter />;
}

export default App;
